import React from "react";
import PropTypes from "prop-types";
import { TabList, Tab } from "discover.medical.react-component-library";
import { StyledDrugMobileTocTabsWrapper } from "./styled";
import { setDrugMobileTocActiveTab } from "../../store/actions";
import { useDispatch } from "../../store";

export function DrugMobileTocTabs({ tabs, activeTab }) {
  const dispatch = useDispatch();
  const activeTabIndex = tabs?.findIndex((tab) => tab.testId === activeTab);

  return (
    <StyledDrugMobileTocTabsWrapper>
      <TabList
        data-testid="drug-mobile-toc-tab-list"
        aria-label="Drug Monograph Tabs"
        activeTab={activeTabIndex}
      >
        {tabs.map(({ path, label, testId }) => (
          <Tab
            id={testId}
            data-testid={testId}
            aria-controls={`${testId}-panel`}
            key={path}
            label={label}
            onClick={() => {
              setDrugMobileTocActiveTab(dispatch, testId);
            }}
          ></Tab>
        ))}
      </TabList>
    </StyledDrugMobileTocTabsWrapper>
  );
}

DrugMobileTocTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      testId: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
};

DrugMobileTocTabs.displayName = "DrugMobileTocTabs";
